import { style } from '@/styles/globals';

export const LuggageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M5.25 5.25024C5.25 4.65351 5.48705 4.08121 5.90901 3.65925C6.33097 3.2373 6.90326 3.00024 7.5 3.00024H10.875C11.4717 3.00024 12.044 3.2373 12.466 3.65925C12.8879 4.08121 13.125 4.65351 13.125 5.25024V6.00024H5.25V5.25024Z"
      stroke="#5E667A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 9.37524L8.81812 11.2049C8.93737 11.2349 9.06263 11.2349 9.18188 11.2049L16.5 9.37524V14.2502C16.5 14.4492 16.421 14.6399 16.2803 14.7806C16.1397 14.9212 15.9489 15.0002 15.75 15.0002H2.25C2.05109 15.0002 1.86032 14.9212 1.71967 14.7806C1.57902 14.6399 1.5 14.4492 1.5 14.2502V9.37524Z"
      stroke="#5E667A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 10.1252V6.75024C16.5 6.55133 16.421 6.36057 16.2803 6.21991C16.1397 6.07926 15.9489 6.00024 15.75 6.00024H2.25C2.05109 6.00024 1.86032 6.07926 1.71967 6.21991C1.57902 6.36057 1.5 6.55133 1.5 6.75024V10.1252"
      stroke="#5E667A"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.9375 8.62524C9.9375 8.87389 9.83873 9.11234 9.66291 9.28816C9.4871 9.46397 9.24864 9.56275 9 9.56275C8.75136 9.56275 8.5129 9.46397 8.33709 9.28816C8.16127 9.11234 8.0625 8.87389 8.0625 8.62524C8.0625 8.3766 8.16127 8.13815 8.33709 7.96233C8.5129 7.78652 8.75136 7.68774 9 7.68774C9.24864 7.68774 9.4871 7.78652 9.66291 7.96233C9.83873 8.13815 9.9375 8.3766 9.9375 8.62524Z"
      fill="#5E667A"
    />
  </svg>
);

export const AllowanceBaggageIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="20"
    viewBox="0 0 14 20"
    fill="none"
  >
    <path
      d="M4.44562 16H2.96375V7H4.44562V16ZM7.65634 16H6.17447V7H7.65634V16ZM10.8671 16H9.3852V7H10.8671V16ZM11.855 4H9.87915V1C9.87915 0.45 9.43459 0 8.89124 0H4.93958C4.39622 0 3.95166 0.45 3.95166 1V4H1.97583C0.889124 4 0 4.9 0 6V17C0 18.1 0.889124 19 1.97583 19C1.97583 19.55 2.42039 20 2.96375 20C3.5071 20 3.95166 19.55 3.95166 19H9.87915C9.87915 19.55 10.3237 20 10.8671 20C11.4104 20 11.855 19.55 11.855 19C12.9417 19 13.8308 18.1 13.8308 17V6C13.8308 4.9 12.9417 4 11.855 4ZM5.43353 1.5H8.39728V4H5.43353V1.5ZM11.855 17H1.97583V6H11.855V17Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const LunchIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.6654 7.33289C14.6654 4.01922 11.6807 1.33289 7.9987 1.33289C4.3167 1.33289 1.33203 4.01922 1.33203 7.33289H14.6654Z"
      stroke={color || style.color.black2}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33203 12.6669H14.6654V14.6669H1.33203V12.6669Z"
      stroke={color || style.color.black2}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33203 9.33289L3.15037 10.6662L5.57437 9.33289L7.9987 10.6662L10.423 9.33289L12.847 10.6662L14.6654 9.33289"
      stroke={color || style.color.black2}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const RefundIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M5.06142 3.88098C8.33475 1.19848 13.1722 1.38515 16.2281 4.44098C19.4822 7.69515 19.4822 12.9718 16.2281 16.226C12.9739 19.4802 7.69725 19.4802 4.44308 16.226C3.44444 15.2287 2.71565 13.994 2.32513 12.6377C1.93462 11.2815 1.8952 9.84829 2.21058 8.47265L2.27475 8.21182L3.88642 8.63682C3.48687 10.1554 3.63616 11.7662 4.30798 13.1855C4.9798 14.6047 6.13103 15.7413 7.55878 16.3949C8.98653 17.0485 10.5992 17.1771 12.1125 16.7581C13.6258 16.3392 14.9426 15.3995 15.8309 14.1047C16.7193 12.8099 17.122 11.2431 16.9683 9.68037C16.8145 8.11768 16.1141 6.65941 14.9905 5.56257C13.8668 4.46573 12.3921 3.8007 10.8261 3.6847C9.26021 3.56871 7.70357 4.00917 6.43058 4.92848L6.24642 5.06682L7.09392 5.91432L3.26392 6.79765L4.14725 2.96765L5.06058 3.88098H5.06142ZM11.1689 5.33348V7.00015H13.2523V8.66682H8.66892C8.5648 8.66663 8.46438 8.70542 8.38743 8.77557C8.31049 8.84572 8.26259 8.94214 8.25319 9.04584C8.24378 9.14953 8.27354 9.25299 8.3366 9.33584C8.39966 9.4187 8.49146 9.47493 8.59392 9.49348L8.66892 9.50015H12.0023C12.5548 9.50015 13.0847 9.71964 13.4754 10.1103C13.8661 10.501 14.0856 11.0309 14.0856 11.5835C14.0856 12.136 13.8661 12.6659 13.4754 13.0566C13.0847 13.4473 12.5548 13.6668 12.0023 13.6668H11.1689V15.3335H9.50225V13.6668H7.41892V12.0002H12.0023C12.1064 12.0003 12.2068 11.9615 12.2837 11.8914C12.3607 11.8212 12.4086 11.7248 12.418 11.6211C12.4274 11.5174 12.3976 11.414 12.3346 11.3311C12.2715 11.2483 12.1797 11.192 12.0773 11.1735L12.0023 11.1668H8.66892C8.11638 11.1668 7.58648 10.9473 7.19578 10.5566C6.80508 10.1659 6.58558 9.63602 6.58558 9.08348C6.58558 8.53095 6.80508 8.00105 7.19578 7.61034C7.58648 7.21964 8.11638 7.00015 8.66892 7.00015H9.50225V5.33348H11.1689Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const DateRangeIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M5.83333 9.16663H7.5V10.8333H5.83333V9.16663ZM17.5 4.99996V16.6666C17.5 17.5833 16.75 18.3333 15.8333 18.3333H4.16667C3.24167 18.3333 2.5 17.5833 2.5 16.6666L2.50833 4.99996C2.50833 4.08329 3.24167 3.33329 4.16667 3.33329H5V1.66663H6.66667V3.33329H13.3333V1.66663H15V3.33329H15.8333C16.75 3.33329 17.5 4.08329 17.5 4.99996ZM4.16667 6.66663H15.8333V4.99996H4.16667V6.66663ZM15.8333 16.6666V8.33329H4.16667V16.6666H15.8333ZM12.5 10.8333H14.1667V9.16663H12.5V10.8333ZM9.16667 10.8333H10.8333V9.16663H9.16667V10.8333Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const ChooseSeatIcon = ({ color }: { color?: string }) => (

  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9994 13.7498L17.4994 1.6665C17.4994 1.6665 13.1244 2.49984 13.1244 4.1665C13.1244 5.20817 14.791 5.83317 14.166 6.45817C13.541 7.08317 11.2493 7.70817 11.2493 9.37484C11.2493 10.4165 11.9327 11.1915 11.2493 11.8748C10.6243 12.4998 9.99935 12.1723 8.95768 11.8748C7.79102 11.5415 5.41602 11.2498 4.58268 11.4582C3.74935 11.6665 2.91602 12.0832 2.91602 13.3332C2.91602 14.0207 3.33268 14.7915 4.37435 14.9998C5.41602 15.2082 6.66602 14.1665 8.33268 14.1665C9.99935 14.1665 12.0827 15.4165 13.3327 15.4165C14.5827 15.4165 14.9994 13.7498 14.9994 13.7498Z"
      stroke={color || style.color.black2}
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M4.58203 14.9999L3.33203 18.3332H17.082L14.582 14.9999"
      stroke={color || style.color.black2}
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>

);

export const CancelFareIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM2.5 2.5V17.5H17.5V2.5H2.5ZM14.1667 12.9917L12.9917 14.1667L10 11.175L7.00833 14.1667L5.83333 12.9917L8.825 10L5.83333 7.00833L7.00833 5.83333L10 8.825L12.9917 5.83333L14.1667 7.00833L11.175 10L14.1667 12.9917Z"
      fill={color || style.color.black2}
    />
  </svg>

);
export const ChangeFareIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 1C5.032 1 1 4.91547 1 9.73988C1 14.5643 5.032 18.4798 10 18.4798C14.968 18.4798 19 14.5643 19 9.73988C19 4.91547 14.968 1 10 1ZM10 16.7318C6.031 16.7318 2.8 13.5942 2.8 9.73988C2.8 5.88559 6.031 2.74798 10 2.74798C13.969 2.74798 17.2 5.88559 17.2 9.73988C17.2 13.5942 13.969 16.7318 10 16.7318ZM13.753 12.1521L12.763 11.1907C13.402 10.0283 13.24 8.56 12.232 7.58113C11.611 6.97808 10.81 6.68092 10 6.68092C9.973 6.68092 9.946 6.68966 9.919 6.68966L10.9 7.64231L9.946 8.56874L7.399 6.09535L9.946 3.62196L10.9 4.54839L10.036 5.38742C11.179 5.39616 12.313 5.80693 13.186 6.64596C14.716 8.14048 14.905 10.4566 13.753 12.1521ZM12.601 13.3844L10.054 15.8578L9.1 14.9314L9.955 14.1011C8.821 14.0923 7.687 13.6641 6.823 12.8251C5.284 11.3305 5.095 9.02321 6.247 7.32767L7.237 8.28906C6.598 9.45147 6.76 10.9198 7.768 11.8986C8.398 12.5104 9.235 12.8076 10.072 12.7814L9.1 11.8375L10.054 10.911L12.601 13.3844Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const PrioryIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
  >
    <path
      d="M19.7583 6.97955L12.6552 6.38185L9.87916 0L7.10311 6.39149L0 6.97955L5.39402 11.5394L3.77384 18.3165L9.87916 14.7207L15.9845 18.3165L14.3742 11.5394L19.7583 6.97955ZM9.87916 12.918L6.16459 15.1063L7.15251 10.9803L3.87263 8.20386L8.1997 7.83753L9.87916 3.95251L11.5685 7.84717L15.8956 8.2135L12.6157 10.9899L13.6036 15.1159L9.87916 12.918Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const WaitingRoomIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M15.75 7.06641V5.56641C15.75 4.32891 14.7375 3.31641 13.5 3.31641H4.5C3.2625 3.31641 2.25 4.32891 2.25 5.56641V7.06641C1.0125 7.06641 0 8.07891 0 9.31641V13.0664C0 14.3039 1.0125 15.3164 2.25 15.3164H15.75C16.9875 15.3164 18 14.3039 18 13.0664V9.31641C18 8.07891 16.9875 7.06641 15.75 7.06641ZM3.75 5.56641C3.75 5.15391 4.0875 4.81641 4.5 4.81641H13.5C13.9125 4.81641 14.25 5.15391 14.25 5.56641V7.65141C13.7925 8.06391 13.5 8.65641 13.5 9.31641V10.8164H4.5V9.31641C4.5 8.65641 4.2075 8.06391 3.75 7.65141V5.56641ZM16.5 13.0664C16.5 13.4789 16.1625 13.8164 15.75 13.8164H2.25C1.8375 13.8164 1.5 13.4789 1.5 13.0664V9.31641C1.5 8.90391 1.8375 8.56641 2.25 8.56641C2.6625 8.56641 3 8.90391 3 9.31641V12.3164H15V9.31641C15 8.90391 15.3375 8.56641 15.75 8.56641C16.1625 8.56641 16.5 8.90391 16.5 9.31641V13.0664Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const ScoreRatioIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M9.99935 18.6497C13.2152 18.6497 15.8327 16.0322 15.8327 12.8164C15.8327 9.60053 13.2152 6.98303 9.99935 6.98303C6.78268 6.98303 4.16602 9.60053 4.16602 12.8164C4.16602 16.0322 6.78268 18.6497 9.99935 18.6497ZM9.99935 8.6497C12.2969 8.6497 14.166 10.5189 14.166 12.8164C14.166 15.1139 12.2969 16.983 9.99935 16.983C7.70185 16.983 5.83268 15.1139 5.83268 12.8164C5.83268 10.5189 7.70185 8.6497 9.99935 8.6497ZM9.16602 1.98303H5.83268V6.58137C6.82992 5.91405 7.97333 5.49699 9.16602 5.36553V1.98303ZM14.166 1.98303H10.8327V5.36553C12.0254 5.49699 13.1688 5.91405 14.166 6.58137V1.98303Z"
      fill={color || style.color.black2}
    />
    <path
      d="M8.34893 13.4922L7.95893 15.7639L9.99977 14.6914L12.0406 15.7639L11.6506 13.4922L13.3023 11.8822L11.0206 11.5505L9.99977 9.48303L8.97893 11.5505L6.69727 11.8822L8.34893 13.4922Z"
      fill={color || style.color.black2}
    />
  </svg>
);

export const ChangeFareInfo = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M13.7296 5.6563L15.4946 7.42047L13.7296 5.6563ZM14.8646 4.10214L10.0921 8.87464C9.84554 9.12089 9.67737 9.43462 9.6088 9.7763L9.16797 11.983L11.3746 11.5413C11.7163 11.473 12.0296 11.3055 12.2763 11.0588L17.0488 6.2863C17.1922 6.14289 17.306 5.97263 17.3836 5.78525C17.4612 5.59787 17.5012 5.39704 17.5012 5.19422C17.5012 4.9914 17.4612 4.79057 17.3836 4.60319C17.306 4.41581 17.1922 4.24555 17.0488 4.10214C16.9054 3.95872 16.7351 3.84496 16.5477 3.76734C16.3604 3.68973 16.1595 3.64978 15.9567 3.64978C15.7539 3.64978 15.5531 3.68973 15.3657 3.76734C15.1783 3.84496 15.008 3.95872 14.8646 4.10214V4.10214Z"
      stroke={color || style.color.black2}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.834 13.6496V16.1496C15.834 16.5916 15.6584 17.0156 15.3458 17.3281C15.0333 17.6407 14.6093 17.8163 14.1673 17.8163H5.00065C4.55862 17.8163 4.1347 17.6407 3.82214 17.3281C3.50958 17.0156 3.33398 16.5916 3.33398 16.1496V6.98295C3.33398 6.54092 3.50958 6.117 3.82214 5.80444C4.1347 5.49188 4.55862 5.31628 5.00065 5.31628H7.50065"
      stroke={color || style.color.black2}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MapPin = ({ color }: { color?: string }) => (
  <svg
    width={16}
    height={17}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      opacity={0.8}
      clipPath="url(#a)"
      stroke={color || style.color.black4}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 7.167c0 4.666-6 8.666-6 8.666s-6-4-6-8.666a6 6 0 1 1 12 0Z" />
      <path d="M8 9.167a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          transform="translate(0 .5)"
          d="M0 0h16v16H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
